export default __webpack_public_path__ + "static/banner_uk_web-130ceaf59b72162153bfac85f1e68639.webp";